import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { TheWestSection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'
import {
    getResolvedTopicPageMeta,
    StaticRoutes,
    Topic,
} from '@news-mono/web-common'
import { layout } from '../../../App.routing'

export const desktopLandingBanner1x = require('./assets/landing-desktop-1x.jpg')
export const desktopLandingBanner2x = require('./assets/landing-desktop-2x.jpg')
export const mobileLandingBanner1x = require('./assets/landing-mobile-1x.jpg')
export const mobileLandingBanner2x = require('./assets/landing-mobile-2x.jpg')
export const socialShareImage = require('./assets/social-share.jpg')

export const queenElizabethTributesRoute: StaticRoutes<TheWestSection> = {
    '/news/queen-elizabeth-ii/tributes': ({
        getAdTargeting,
        store,
        config,
        resolution,
        log,
    }) => {
        const canonicalUrl =
            config.publicUrl + '/news/queen-elizabeth-ii/tributes'

        const topic: Topic = {
            id:
                getResolvedTopicPageMeta(resolution)?.id ||
                'news/queen-elizabeth-ii/tributes',
            metadata: {},
            title: 'Tributes for Queen Elizabeth II',
            seoTitle:
                getResolvedTopicPageMeta(resolution)?.seoTitle ||
                'Tributes for Queen Elizabeth II',
            seoDescription:
                getResolvedTopicPageMeta(resolution)?.seoDescription ||
                `Leave your personal tributes here for Queen Elizabeth II - Britain's longest-serving monarch who died at the age of 96.`,
        }

        const getSocialImageMeta = [
            {
                property: 'og:image',
                content: socialShareImage,
            },
            { name: 'twitter:image', content: socialShareImage },
            {
                property: 'og:image:height',
                content: '643',
            },
            {
                property: 'og:image:width',
                content: '1224',
            },
            {
                property: 'og:description',
                content: topic.seoDescription,
            },
            {
                property: 'twitter:description',
                content: topic.seoDescription,
            },
        ]

        const isEnabled = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'queen-elizabeth-tributes-route',
            true,
        )

        if (!isEnabled) {
            return null
        }

        return {
            kind: 'page',
            heading: topic.title,
            pageType: 'topic',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: topic.title,
                description: topic.seoDescription,
                seoTitle: topic.seoTitle,
                seoDescription: topic.seoDescription,
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getSocialImageMeta,
            },
            adTargeting: getAdTargeting('home', 'default', topic),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'athena',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        elementType: 'div',
                        sidebarOptions: 'hiddenMobile',
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'image-banner',
                                props: {
                                    defaultSrc: desktopLandingBanner2x,
                                    verticalGutters: ['unset', 'md'],
                                    altText: 'Leave your tribute to the Queen',
                                    sources: [
                                        {
                                            breakpoint: 'md',
                                            src: [
                                                {
                                                    src: desktopLandingBanner1x,
                                                    density: '1x',
                                                },
                                                {
                                                    src: desktopLandingBanner2x,
                                                    density: '2x',
                                                },
                                            ],
                                        },
                                        {
                                            src: [
                                                {
                                                    src: mobileLandingBanner1x,
                                                    density: '1x',
                                                },
                                                {
                                                    src: mobileLandingBanner2x,
                                                    density: '2x',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            }),
                            layout.component({
                                type: 'guestbook',
                                props: {
                                    campaign: `Queen's Tribute`,
                                    logger: log,
                                    onEvent: () => {},
                                },
                            }),
                        ],

                        // SIDEBAR
                        sidebar: [
                            layout.component({
                                type: 'ad-unit',
                                props: {
                                    noticePosition: 'below-center',
                                    padding: [
                                        0,
                                        0,
                                        metrics.thewest.margins.md,
                                        0,
                                    ],
                                    slot: {
                                        id: 'sidebar-top',
                                        size: 'desktopMrecHalfPage',
                                        pageType: 'static',
                                    },
                                    adType: 'inline',
                                },
                            }),

                            layout.nestedComposition({
                                type: 'box',
                                props: {
                                    stickyOffset: 350,
                                    fillContainer: true,
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'ad-unit',
                                            props: {
                                                noticePosition: 'below-center',
                                                padding: [
                                                    0,
                                                    0,
                                                    metrics.thewest.margins.md,
                                                    0,
                                                ],
                                                slot: {
                                                    id: 'sidebar-middle',
                                                    size: 'desktopMrec',
                                                    pageType: 'static',
                                                },
                                                adType: 'inline',
                                            },
                                        }),
                                    ],
                                },
                            }),
                        ],
                    },
                }),
            ],
        }
    },
}
